import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const SEND_USER_TASK_REMINDER = 'SEND_USER_TASK_REMINDER';

export const service = async (userTaskId) => {
  const options: object = {
    url:  "/Api/UserTasks/SendUserTaskReminder" ,
    method: "POST",
    body: JSON.stringify(userTaskId),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SEND_USER_TASK_REMINDER, service, mock);
